import React from 'react'
import ScrollToTop from '../components/ScrollToTop.js'
import SignIn from '../components/Signin/index.js'

const SigninPage = () => {
    return (
        <>
            <ScrollToTop />
            <SignIn />
        </>
    )
}

export default SigninPage
